// extracted by mini-css-extract-plugin
export default {"container":"ComparatorList_container__-xWSX","add":"ComparatorList_add__R-Fx+","select-container":"ComparatorList_select-container__Q6VYe","select":"ComparatorList_select__ICWa-"};